import React from 'react';
import { Box, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';


import ContactPageIcon from '@mui/icons-material/ContactPage';
import BuildIcon from '@mui/icons-material/Build';
import SendIcon from '@mui/icons-material/Send';
import BarChartIcon from '@mui/icons-material/BarChart';

// Se o usuario for admin deve-se ter um menu para cadastro de usuarios

const Menu = ({ isAdmin })=>{   
    // Funcao para alternancia de rota
    const history = useHistory();
    const fnRota = rota=> {
        history.push(rota);
    }
    
    //
    const menu = [
        {icone: <ContactPageIcon />, texto: 'Ver Curriculos', url: '/curriculo', titulo: 'Navegue até os curriculos'},
        {icone: <BarChartIcon />, texto: 'Estatisticas', url: '/curriculo_estatisticas', titulo: 'Visualize graficos e informações estatisticas'},
    ];
    if(isAdmin){
        menu.push(
            {icone: <BuildIcon />, texto: 'Manutenção', url: '/manutencao', titulo: 'Navegue até a area de manutencao'}
        );
        // Determina a parte para edição das mensagens, tanto do termo aceite quanto do WhatsApp
        menu.push(
            {icone: <SendIcon />, texto: 'Mensagens', url: '/cadastro_mensagens', titulo: 'Altere mensagens do whatsApp ou termo aceite'}
        )
    }
    
    return (
        <Box sx={{display: 'flex', flexDirection: 'row'}}> 
            {menu.map((ele,idx)=>(
                
                    <Button onClick={()=> fnRota(ele.url)} 
                        key={idx} sx={{mx: 2}}
                        startIcon={ele.icone} title={ele.titulo}
                    >                        
                        {ele.texto }
                    </Button>
                
            ))}
        </Box>
    )
}

export default Menu;